export default __webpack_public_path__ + "static/media/gwn21.104629a9.webp";